//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/Section.js";
import "../no/SelectBodyList.js";
import "../no/Section.js";
import "../no/SelectObjectList.js";
let d=[[[0,"BendingColor",1,0],[0,"BlankSize",1,0],[0,"BurringColor",1,0],[0,"CamunitColor",1,0],[0,"CompFactor",1,0],[0,"Customer",1,0],[0,"DesignHours",1,0],[0,"DesignPrice",1,0],[0,"DistanceX",1,0],[0,"DistanceY",1,0],[0,"FormingColor",1,0],[0,"InsertGroupMaterial",1,0],[0,"ManageTemporaryObjectsType",1,0],[0,"MaterialUtil",1,0],[0,"ObjectType",1,0],[0,"OutlineEnlargeTimes",1,0],[0,"PartNo",1,0],[0,"PartsAmout",1,0],[0,"PiercingColor",1,0],[0,"Pitch",1,0],[0,"QuoteDate",1,0],[0,"QuoteNo",1,0],[0,"Quoter",1,0],[1,"SelOutline",0,"Section",0],[1,"SelSheetBody",0,"SelectBodyList",0],[0,"StationsNo",1,0],[0,"StripLength",1,0],[0,"StripMaterial",1,0],[0,"StripThickness",1,0],[0,"Type",1,0],[0,"Width",1,0],[0,"WorkAreaLength",1,0],[0,"WorkAreaWidth",1,0]],[[[],"DatumPlane",{},0,0],[[],"TemplateConfig",{},0,0]],[]];
SPLM.Tooling.QuickQuotationBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.QuickQuotationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.QuickQuotationBuilder.Types = Object.freeze({
    "JobInformation" : "JobInformation", "ProjectDefinition" : "ProjectDefinition", "ConceptDesign" : "ConceptDesign", "Grouping" : "Grouping", "Quoting" : "Quoting"});

SPLM.Tooling.QuickQuotationBuilder.DesignTypes = Object.freeze({
    "NewDesign" : "NewDesign", "Changeover" : "Changeover", "AdditionalDie" : "AdditionalDie"});

SPLM.Tooling.QuickQuotationBuilder.ObjectTypes = Object.freeze({
    "Piercing" : "Piercing", "Bending" : "Bending", "Forming" : "Forming", "Burring" : "Burring", "Cam" : "Cam"});

SPLM.Tooling.QuickQuotationBuilder.InsertGroupMaterials = Object.freeze({
    "Cr12" : "Cr12", "Cr12MoV" : "Cr12MoV"});

SPLM.Tooling.QuickQuotationBuilder.ManageTemporaryObjectsTypes = Object.freeze({
    "Hide" : "Hide", "Display" : "Display", "Delete" : "Delete"});

export default SPLM;